import omit from "ramda/es/omit";
import pick from "ramda/es/pick";
import keyMirror from "ramda-extension/es/keyMirror";
const codelistActionTypes = keyMirror({
    CODELIST_LOAD_DATA_REGISTER: null,
    CODELIST_LOAD_DATA_REQUEST: null,
    CODELIST_LOAD_DATA_SUCCESS: null,
    CODELIST_LOAD_DATA_FAIL: null,
    CODELIST_DATA_CLEAR: null
});
export const codelistContainerListProps = [
    'callCodelistAPI',
    'callCodelistAPICredentials',
    'callCodelistApiRemoteDataConverter',
    'clearCodelistInStore',
    'convertDataIntoChildAcceptableFormat',
    'endpoint',
    'handDataOverToChildPropName',
    'howToHandDataOverToChild',
    'name',
    'oauth2',
    'parentFilter',
    'parentFilterUrlParam',
    'storeKey',
    'waitForParentFilterValue'
];
export const omitCodelistContainerProps = omit(codelistContainerListProps);
export const pickCodelistContainerProps = pick(codelistContainerListProps);
const codelistLoadingStates = keyMirror({
    REGISTERED: null,
    LOADING: null,
    SUCCESS: null,
    FAIL: null
});
const howToHandDataOverToChildType = keyMirror({
    CHILD: null,
    PROP: null
});
export const REDUCER_NAME = 'codelists';
export { codelistActionTypes };
export { codelistLoadingStates };
export { howToHandDataOverToChildType };
export default {
    codelistActionTypes,
    codelistLoadingStates,
    howToHandDataOverToChildType
};
